import { render, staticRenderFns } from "./PrescriptionPage.vue?vue&type=template&id=7bc4f440&scoped=true"
import script from "./PrescriptionPage.vue?vue&type=script&lang=js"
export * from "./PrescriptionPage.vue?vue&type=script&lang=js"
import style0 from "./PrescriptionPage.vue?vue&type=style&index=0&id=7bc4f440&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc4f440",
  null
  
)

export default component.exports